var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"props-group"},[_c('el-form-item',{attrs:{"label":"行数"}},[_c('el-input-number',{attrs:{"min":1,"max":"20"},model:{value:(_vm.component.properties.numberOfLines),callback:function ($$v) {_vm.$set(_vm.component.properties, "numberOfLines", $$v)},expression:"component.properties.numberOfLines"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2397c89e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/row-col.vue
// module id = null
// module chunks = 